import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "row g-2 ps-3" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "input-group input-group-sm" }
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between mb-1" }
const _hoisted_8 = { class: "form-check form-switch d-flex align-items-center gap-2 mb-0 ps-0" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = { class: "input-group input-group-sm" }
const _hoisted_11 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelBasicInfo',
  props: {
  id: { type: String, default: "" },
  name: { type: String, default: "" },
  priority: { type: Number, default: 0 },
  active: { type: Boolean, default: true },
  disabledId: { type: Boolean, default: false },
},
  emits: ["update:id", "update:name", "update:priority", "update:active"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "fw-bold text-dark mb-2" }, [
      _createElementVNode("i", { class: "fas fa-info-circle fa-fw me-2 text-success" }),
      _createTextVNode("Información Básica ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, [
          _createTextVNode(" ID de Telegram "),
          _createElementVNode("span", { class: "text-danger" }, "*")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "input-group-text bg-light border-end-0 text-muted" }, [
            _createElementVNode("i", { class: "fas fa-hashtag" })
          ], -1)),
          _createElementVNode("input", {
            value: __props.id,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (
              _ctx.$emit('update:id', ($event.target as HTMLInputElement).value)
            )),
            type: "text",
            class: _normalizeClass(["form-control border-start-0", { ' bg-light': !__props.disabledId }]),
            placeholder: "Ej. -1001234567890",
            disabled: __props.disabledId,
            required: "",
            style: {"border-left":"0"}
          }, null, 42, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-0" }, [
            _createTextVNode(" Nombre del Canal "),
            _createElementVNode("span", { class: "text-danger" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              class: "form-check-label text-muted fw-bold small mb-1",
              for: "activeToggle"
            }, " Activo ", -1)),
            _createElementVNode("input", {
              checked: __props.active,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.$emit(
                  'update:active',
                  ($event.target as HTMLInputElement).checked
                )
              )),
              class: "form-check-input cursor-pointer success m-0 me-2",
              type: "checkbox",
              id: "activeToggle"
            }, null, 40, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text bg-light border-end-0 text-muted" }, [
            _createElementVNode("i", { class: "fas fa-signature" })
          ], -1)),
          _createElementVNode("input", {
            value: __props.name,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.$emit('update:name', ($event.target as HTMLInputElement).value)
            )),
            type: "text",
            class: "form-control bg-light border-start-0",
            placeholder: "Ej. GTR Official News",
            required: "",
            style: {"border-left":"0"}
          }, null, 40, _hoisted_11)
        ])
      ])
    ])
  ]))
}
}

})